import { render, staticRenderFns } from "./ProductListWrapper.vue?vue&type=template&id=a6d19f8e&scoped=true&"
import script from "./ProductListWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductListWrapper.vue?vue&type=style&index=0&id=a6d19f8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d19f8e",
  null
  
)

export default component.exports